export class Target {
  id: string;
  name: string;

  constructor(jsonNegotiationType: JsonFilteredTarget = null) {
    this.id = jsonNegotiationType.id;
    this.name = jsonNegotiationType.name;
  }
}

export interface JsonFilteredTarget {
  id: string;
  name: string;
}

export class FilteredTarget {
  id: string;
  name?: string;

  constructor(jsonFiltered: JsonFilteredTarget) {
    if (jsonFiltered.id) {
      this.id = jsonFiltered.id;
    }

    if (jsonFiltered.name) {
      this.name = jsonFiltered.name;
    }
  }
}

export interface JsonTargetWithAudience {
  targetName: string;
  targetId: string | null;
  averageContacts: string;
  effectif: string | null;
  grp: string | null;
}

export class TargetWithAudience {
  targetName: string;
  targetId: string | null;
  averageContacts: number;
  effectif: number | null;
  grp: number | null;

  constructor(jsonTargetWithAudience: JsonTargetWithAudience) {
    this.targetName = jsonTargetWithAudience.targetName;
    this.targetId = jsonTargetWithAudience.targetId;
    this.averageContacts = Number(jsonTargetWithAudience.averageContacts) ? Number(jsonTargetWithAudience.averageContacts) : null;
    this.effectif = Number(jsonTargetWithAudience.effectif) ? Number(jsonTargetWithAudience.effectif) : null;
    this.grp = Number(jsonTargetWithAudience.grp) ? Number(jsonTargetWithAudience.grp) : null;
  }
}
